import React, { useEffect, useRef } from "react";

const pulsePath =
  "M0 50 H470 L500 50 L518 43 L538 58 L562 18 L590 82 L616 50 L642 50 L658 39 L678 61 L702 50 H970 L1000 50 L1018 43 L1038 58 L1062 18 L1090 82 L1116 50 H1440";

function HomeVitalsBackground({ variant = "divider" }) {
  const traceRef = useRef(null);
  const glowRef = useRef(null);
  const leadRef = useRef(null);

  useEffect(() => {
    const trace = traceRef.current;
    const glow = glowRef.current;
    const lead = leadRef.current;
    if (!trace || !glow || !lead) return undefined;

    const length = trace.getTotalLength();
    const visibleLength = length * 0.14;
    const gapLength = length - visibleLength;
    const duration = 5200;
    let animationFrame;
    let startedAt;

    trace.style.strokeDasharray = visibleLength + " " + gapLength;
    glow.style.strokeDasharray = visibleLength + " " + gapLength;

    const drawFrame = (timestamp) => {
      if (startedAt === undefined) startedAt = timestamp;
      const progress = ((timestamp - startedAt) % duration) / duration;
      const distance = progress * length;
      const dashOffset = -distance;
      const point = trace.getPointAtLength(distance);

      trace.style.strokeDashoffset = String(dashOffset);
      glow.style.strokeDashoffset = String(dashOffset);
      lead.setAttribute("cx", String(point.x));
      lead.setAttribute("cy", String(point.y));

      animationFrame = window.requestAnimationFrame(drawFrame);
    };

    animationFrame = window.requestAnimationFrame(drawFrame);
    return () => window.cancelAnimationFrame(animationFrame);
  }, []);

  return (
    <div className={"home-pulse-divider home-pulse-divider--" + variant} aria-hidden="true">
      <svg
        className="home-pulse-divider__svg"
        viewBox="0 0 1440 100"
        preserveAspectRatio="none"
        focusable="false"
      >
        <path className="home-pulse-divider__baseline" d="M0 50 H1440" />
        <path
          ref={glowRef}
          className="home-pulse-divider__glow"
          d={pulsePath}
        />
        <path
          ref={traceRef}
          className="home-pulse-divider__trace"
          d={pulsePath}
        />
        <circle
          ref={leadRef}
          className="home-pulse-divider__lead"
          cx="0"
          cy="50"
          r="4"
        />
      </svg>
    </div>
  );
}

export default HomeVitalsBackground;
